<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-phone-volume text-primary"></i> Enquiry</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Name" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Email :</label>
          <input type="email" class="form-control form-control-sm" v-model="Obj.Email" />
           <span v-if="errors.Email" class="text-danger font-12">{{ errors.Email }}</span>
        </div>
        <div class="col-md-3">
          <label class="form-label">Phone<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="number" class="form-control form-control-sm"  @input="limitDigits($event, 10, v => Obj.Phone = v)" v-model="Obj.Phone" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Enquiry for<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.EnquiryFor" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Type<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.Type">
            <option selected=""></option>
            <option value="Admission">Admission</option>
            <option value="Academic Details">Academic Details</option>
            <option value="Work Timings">Work Timings</option>
            <option value="Salary Packages">Salary Packages</option>
            <option value="Admission">Leaves&Holidays</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.Date" placeholder="dd/mm/yyyy" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Note :</label>
          <textarea class="form-control form-control-sm rounded" aria-label="With textarea" v-model="Obj.Note"></textarea>
        </div>
        <div class="col-md-12 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-12 table-responsive">
          <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
         <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm, isEmail } from "@/utils/validation.js";
import { formatDate, curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
const rows=ref([])
  const  Obj = ref( { Name: "", Email: "", Phone: "", EnquiryFor: "", Type: "",  Date: new Date().toISOString().slice(0, 10), Note: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols = ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name' },
  { label: 'Email', key: 'Email', },
  { label: 'Phone', key: 'Phone' },
  { label: 'EnquiryFor', key: 'EnquiryFor',  },
  { label: 'Type', key: 'Type' },
  { label: 'Date', key: 'enqDate' },
  { label: 'Note', key: 'Note', truncatable: true }
]);
const handleEdit = (row) => {
    Obj.value = { ...row, Date: row.Date ? row.Date.slice(0, 10) : new Date().toISOString().slice(0, 10), }  
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
   const  save =async() => {
      const fields = {
        Name: { value: Obj.value.Name, validators: [isRequired], },
         Phone: { value: Obj.value.Phone, validators: [ (v) => { if (!v) return "Phone No. is required"; if (v.length < 10) return "Phone No. must be 10 digits"; return null; }, ], },
        Email: { value: Obj.value.Email, validators: [isEmail], },
        EnquiryFor: { value: Obj.value.EnquiryFor, validators: [isRequired], },
         Type: { value: Obj.value.Type, validators: [isRequired], },
        Date: { value: Obj.value.Date, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/enquiry${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Enquiry ${msg} Successfuly`, role: "success", show: true, };
          })
          .catch((error) => { console.log(error); });
      }
    }
   const reset =async () =>{
      Obj.value = { Name: "", Email: "", Phone: "", EnquiryFor: "", Type: "",  Date: new Date().toISOString().slice(0, 10), Note: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
   const progress = ref(0)
    const loadData= async()=> {
    let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/enquiry/search') .then((response) =>{ rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1, enqDate: formatDate(item.Date), }));
     progress.value = 0
          clearInterval(progressInterval)
    });
    }
    const delRecord =async () => {
      await api.delete(`/enquiry/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Enquiry Deleted Successfuly.", role: "danger", show: true, };
        });
    }
    onMounted(() => { loadData(); })
</script>